enum FloorType {
    None = "0",
    OnGrade = "1",
    AboveGrade = "2",
    OnGradeHeated = "3",
    BoxSetting = "4"
}

export default FloorType;